module.exports = __webpack_public_path__ + "static/media/tecno_tech.89772953.svg";